// redux utils
import {createAsyncThunk} from '@reduxjs/toolkit';
import store from '../store/store'
// api
import * as ppa from './api/ppa'
// utils
import {displayErrorMessage, displaySuccessMessage} from '@insticator/insticator-ui'

// thunks
export const updateProfileInfo = createAsyncThunk('user/updateProfileInfo',
    async (payload, { rejectWithValue})  => {
        const { userUUID, data } = payload
        try {
            delete data.commentingUser
            const response = await ppa.updateUserInfo(data, userUUID)
            if(response.data && response.status === 200) store.dispatch(displaySuccessMessage('Your profile information has been saved successfully'))
            return response.data
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload?.comment || errResponse?.payload || 'There was a problem updating your profile information'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const addUser = createAsyncThunk('user/addUser',
    async (payload, { rejectWithValue }) => {
        const { accountUUID, data } = payload
        try {
            delete data.commentingUser;
            const response = await ppa.addUser(accountUUID, data);
            if(response.data && response.status === 200) store.dispatch(displaySuccessMessage('User has been added successfully'))
            return response.data
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue adding this User'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
    
);

export const updateUser = createAsyncThunk('user/updateUser',
    async (payload, { rejectWithValue})  => {
        const { userUUID, data } = payload
        try {
            delete data.commentingUser;
            const response = await ppa.updateUser(userUUID, data);
            if(response.data && response.status === 200) store.dispatch(displaySuccessMessage('You have successfully updated this users information'))
            return response.data
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload?.comment || errResponse?.payload || 'There was a problem updating this users information'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const deleteUser = createAsyncThunk(
    'users/deleteUser',
    async payload => {
    const { userUUID, transferredUserUUID } = payload;
    const response = await ppa.deleteUser(userUUID, transferredUserUUID);
    return response.data
});

export const inviteUser = createAsyncThunk(
    'user/inviteUser',
    async userUUID => {
    const response = await ppa.inviteUser(userUUID);
    if(response.status === 200) store.dispatch(displaySuccessMessage('New invitation sent!'))
    else store.dispatch(displayErrorMessage('There was an issue sending invite'))
    return { userUUID }
});

export const resendInvite = createAsyncThunk(
    'user/resendInvite',
    async userUUID => {
    const response = await ppa.resendInvite(userUUID, true);
    if(response.status === 200) store.dispatch(displaySuccessMessage('New invitation link sent'))
    else store.dispatch(displayErrorMessage('Sending invitation failed'))
    return { userUUID }
});